import React from "react";

/** Route chunk loader — no full-screen Lottie; pages show their own skeletons. */
const Loading = () => null;

export default Loading;
